<template>
  <address>
    <p><strong>{{ address.firstname + ' ' + address.lastname }}</strong></p>
    <p v-if="address.company">{{ address.company }}</p>
    <p>{{ address.address1 }}</p>
    <p v-if="address.address2">{{ address.address2 }}</p>
    <p v-if="address.address3">{{ address.address3 }}</p>
    <p>{{ region(address) }}</p>
    <p v-if="address.phone">{{ 'Phone: ' + address.phone }}</p>
    <slot/>
  </address>
</template>

<style scoped>
address {
  margin-bottom: 0;
}
address p {
  margin: 0;
}
</style>

<script>

export default {
    props: {
        address: {
            type: Object,
            default: null
        }
    },

    methods: {
        region: function(address) {
            let region = address.city || ''
            if (address.countryID === 1) {
                region += ', ' + (address.statecode || '') +
                    ' ' + (address.zip || '')
            } else {
                region += ', ' + (address.province || '') +
                    ' ' + (address.zip || '') +
                    '<br>' + (address.countryname || '&nbsp;')
            }
            return region
        },
    }
}
</script>
